<template>
  <DialogContainer v-model="dialogObj">
    <template v-slot:dialogSlot>
      <div class="business-body custom-form" v-loading="loading">
        <el-row :gutter="20">
          <el-form ref="form" :model="form" :rules="rules" label-position="top">
            <div class="title-ce">
              <div class="title-box">
                <el-image :src="cheImage" class="title-label"></el-image
                >司机当前地址距装货地距离
              </div>
              <div>
                导航距离<span class="label-text">{{ distance1 || "-" }}</span
                >，预计<span class="label-text">{{ duration1 || "-" }}</span>
              </div>
            </div>
            <el-col :span="24">
              <el-form-item
                label="出发地 （默认选中司机当前位置作为出发地）"
                prop="startDot1"
              >
                <el-select
                  style="width: 100%"
                  v-model="form.startDot1"
                  filterable
                  clearable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in lngAndLatList"
                    :key="item.id"
                    :disabled="!item.lngAndLat"
                    :label="`${item.name}`"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="目的地" prop="endDot1">
                <el-select
                  style="width: 100%"
                  v-model="form.endDot1"
                  filterable
                  clearable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in lngAndLatList"
                    :key="item.id"
                    :disabled="!item.lngAndLat"
                    :label="`${item.name}`"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <div class="title-ce">
              <div class="title-box">
                <el-image :src="cheImage" class="title-label"></el-image
                >司机已接订单距装货地距离
              </div>
              <div>
                导航距离<span class="label-text">{{ distance2 || "-" }}</span
                >，预计<span class="label-text">{{ duration2 || "-" }}</span>
              </div>
            </div>
            <el-col :span="24">
              <el-form-item
                label="出发地 （默认选中司机最新接单的装货地址作为出发地）"
                prop="startDot2"
              >
                <el-select
                  style="width: 100%"
                  v-model="form.startDot2"
                  filterable
                  clearable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in lngAndLatList"
                    :key="item.id"
                    :disabled="!item.lngAndLat"
                    :label="`${item.name}`"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="目的地" prop="endDot2">
                <el-select
                  style="width: 100%"
                  v-model="form.endDot2"
                  filterable
                  clearable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in lngAndLatList"
                    :key="item.id"
                    :disabled="!item.lngAndLat"
                    :label="`${item.name}`"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
      </div>
    </template>
  </DialogContainer>
</template>

<script>
import DialogContainer from "@/components/Dialog.vue";
import { getDistanceAndDuration } from "@/utils/distanceService";
import { getLastedPointReport, getTodayReport } from "@/views/commonApi";
export default {
  name: "AddOrEdit",
  components: {
    DialogContainer,
  },
  data() {
    return {
      cheImage: require("@/assets/imgs/title.png"),
      loading: false,
      dialogObj: {
        loading: false,
        btnLoading: false,
        width: "40%",
        show: false,
        title: "导航测算",
        closeOnClickModal: false,
        confirmFn: this.submitForm,
        confirmTxt: "导航测算",
        beforeClose: (v) => {
          this.form = this.$options.data().form;
          if (this.$refs.form) this.$refs.form.resetFields();
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      lngAndLatList: [], // 需要测算的经纬度数据
      form: {
        // 司机当前地址距装货地距离
        startDot1: null, // 司机当前地址位置
        endDot1: null, // 装货地位置
        // 司机已接订单距装货地距离
        startDot2: null, // 司机已接订单位置
        endDot2: null, // 装货地位置
      },
      distance1: "",
      duration1: "",
      distance2: "",
      duration2: "",
      rules: {
        // startDot1: [{ required: true, message: "司机当前地址位置不能为空" }],
        // endDot1: [{ required: true, message: "装货地位置不能为空" }],
        // startDot2: [{ required: true, message: "司机已接订单位置不能为空" }],
        // endDot2: [{ required: true, message: "装货地位置不能为空" }],
        startDot1: [{ required: true, message: "位置不能为空" }],
        endDot1: [{ required: true, message: "位置不能为空" }],
        startDot2: [{ required: true, message: "位置不能为空" }],
        endDot2: [{ required: true, message: "位置不能为空" }],
      },
      //       可选地址：
      //
      //   （1）车辆当前位置
      //
      // （2）货源装货地址
      //
      // （3）货源卸货地址
      //
      // （4）司机上报地址
    };
  },
  created() {},
  mounted() {},
  methods: {
    init(obj) {
      this.form.startDot2 = null;
      this.distance1 = "";
      this.duration1 = "";
      this.distance2 = "";
      this.duration2 = "";
      this.lngAndLatList = [];
      // 司机当前位置有 则设置默认
      if (obj.driver.lng) {
        this.form.startDot1 = 1;
      } else {
        this.form.startDot1 = null;
      }
      this.lngAndLatList.push({
        id: 1,
        lngAndLat: obj.driver.lng ? obj.driver.lng + "," + obj.driver.lat : "",
        name: "车辆当前位置",
      });
      this.lngAndLatList.push({
        id: 2,
        lngAndLat:
          obj.order.pointList[0].lng + "," + obj.order.pointList[0].lat,
        name: `货源装货地址：${obj.order.pointList[0].provinceName}${
          obj.order.pointList[0].cityName
        }${
          obj.order.pointList[0].address ? obj.order.pointList[0].address : ""
        }`,
      });
      this.lngAndLatList.push({
        id: 3,
        lngAndLat:
          obj.order.pointList[obj.order.pointList.length - 1].lng +
          "," +
          obj.order.pointList[obj.order.pointList.length - 1].lat,
        name: `货源卸货地址：${
          obj.order.pointList[obj.order.pointList.length - 1].provinceName
        }${obj.order.pointList[obj.order.pointList.length - 1].provinceName}${
          obj.order.pointList[obj.order.pointList.length - 1].address
            ? obj.order.pointList[obj.order.pointList.length - 1].address
            : ""
        }`,
      });
      this.getLastReportAddress(obj.driver.driverId);
      this.getLastedPointReportAddress(obj.driver.driverId);
      this.dialogObj.show = true;
    },
    getLastReportAddress(driverId) {
      this.loading = true;
      let report = {};
      getTodayReport(driverId)
        .then((res) => {
          this.loading = false;
          if (res.code === 200) {
            report = {
              id: 4,
              lngAndLat: res.data.lng ? res.data.lng + "," + res.data.lat : "",
              name: `司机上报地址${
                res.data.address ? "：" + res.data.address : ""
              }`,
            };
          } else {
            report = {
              id: 4,
              lngAndLat: "",
              name: "司机上报地址",
            };
          }
          this.lngAndLatList.push(report);
        })
        .catch((err) => {
          this.loading = false;
          report = {
            id: 4,
            lngAndLat: "",
            name: "司机上报地址",
          };
          this.lngAndLatList.push(report);
        });
    },
    getLastedPointReportAddress(driverId) {
      this.loading = true;
      let report = {};
      getLastedPointReport(driverId)
        .then((res) => {
          this.loading = false;
          if (res.code === 200) {
            this.form.startDot2 = 5;
            report = {
              id: 5,
              lngAndLat: res.data.lng ? res.data.lng + "," + res.data.lat : "",
              name: `最近运输中订单的装货位置：${res.data.provinceName}${
                res.data.cityName
              }${res.data.address ? res.data.address : ""}`,
            };
          } else {
            report = {
              id: 5,
              lngAndLat: "",
              name: "最近运输中订单的装货位置",
            };
          }
          this.lngAndLatList.push(report);
        })
        .catch((err) => {
          this.loading = false;
          report = {
            id: 5,
            lngAndLat: "",
            name: "最近运输中订单的装货位置",
          };
          this.lngAndLatList.push(report);
        });
    },
    fetchAllRoutes(lngAndLat1, lngAndLat2, lngAndLat3, lngAndLat4) {
      const promises = [
        getDistanceAndDuration(lngAndLat1, lngAndLat2),
        getDistanceAndDuration(lngAndLat3, lngAndLat4),
      ];
      this.dialogObj.btnLoading = true;
      Promise.all(promises)
        .then((results) => {
          this.distance1 = this.$day.formatDistance(results[0].distance);
          this.distance2 = this.$day.formatDistance(results[1].distance);
          this.duration1 = this.$day.formatDuration(results[0].duration);
          this.duration2 = this.$day.formatDuration(results[1].duration);
        })
        .finally(() => {
          this.dialogObj.btnLoading = false;
        });
    },
    getLngAndLat(key) {
      let ll = "";
      this.lngAndLatList.forEach((item) => {
        if (item.id === key) {
          ll = item.lngAndLat;
        }
      });
      return ll;
    },
    // 提交数据
    submitForm() {
      // this.fetchAllRoutes();
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 司机当前地址距装货地距离
          // startDot1: 1, // 司机当前地址位置
          // endDot1: "", // 装货地位置
          // 司机已接订单距装货地距离
          // startDot2: 2, // 司机已接订单位置
          // endDot2: "", // 装货地位置
          let lngAndLat1 = this.getLngAndLat(this.form.startDot1);
          let lngAndLat2 = this.getLngAndLat(this.form.endDot1);
          let lngAndLat3 = this.getLngAndLat(this.form.startDot2);
          let lngAndLat4 = this.getLngAndLat(this.form.endDot2);
          this.fetchAllRoutes(lngAndLat1, lngAndLat2, lngAndLat3, lngAndLat4);
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.business-body {
  box-sizing: border-box;
  .title-ce {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.16rem 0.16rem;
    .label-text {
      color: #1269ff;
    }
    .title-box {
      padding-bottom: 0;
    }
  }
  .arrow-box {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .arrow-img {
    width: 0.48rem;
    height: 0.05rem;
    position: relative;
    top: 0.45rem;
  }
}
</style>
